import React from "react";
import { Admin, Resource, ListGuesser, EditGuesser } from "react-admin";
import {AppointmentList,
    ProfileList,
    AppointmentEdit,
    ScheduleAppointment,
    AdminHome,
    Menu,
    AvaliableVetAdmin,
    AddVetSchedule,
    RemoveVetAvailability
} from "../../Components/AdminViews";
import UserIcon from "@material-ui/icons/Group";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import { Route } from "react-router";
import SearchPetParent from "../../Components/AdminViews/SearchPetParent";
import PetParentProfile from "../../Components/AdminViews/PetParentProfile";
import theme from "../../theme";
import {useTheme} from "@material-ui/core";

const AdminPage = ({dataProvider, historyHash, i18nProvider}) => {
    const theme = useTheme();
    return(
        <div style={{marginTop: 20}}>
            <Admin
                //dashboard={AdminHome}
                theme={theme}
                layout={Menu}
                dataProvider={dataProvider}
                history={historyHash}
                i18nProvider={i18nProvider}
                customRoutes={[
                    <Route
                        key="availableVETS"
                        path="/availableVets"
                        component={AvaliableVetAdmin}
                    />,
                    <Route
                        key="addVetSchedule"
                        path="/addVetSchedule"
                        component={AddVetSchedule}
                    />,
                    <Route
                    key="removeVetAvailability"
                    path="/removeVetAvailability"
                    component={RemoveVetAvailability}
                />,
                    <Route
                        key="searchPetParent"
                        path="/searchPetParent"
                        component={SearchPetParent}
                    />,
                    <Route
                        key="petParentProfile"
                        path="/petParentProfile"
                        component={PetParentProfile}
                    />
                ]}
                initialState={{ admin: { ui: { sidebarOpen: true, version: 0 } } }}
            >
                <Resource name="appointments/search" options={{ label: "Appointments" }} list={AppointmentList} edit={AppointmentEdit} icon={LocalHospitalIcon} />
                <Resource name="profiles" options={{ label: "Create Appointment"}} list={ScheduleAppointment} icon={UserIcon} />
            </Admin>
        </div>
    );
};

export default AdminPage;
